import React from "react";
import ReactDOM from "react-dom/client";
import { AppEntry } from "./AppEntry";

// The page as plain HTML for search engines without JavaScript (server/site.js): the app shows its own
document.getElementById("page-content")?.remove();

// Create root element
const rootElement = document.createElement("div");
rootElement.id = "app";
document.body.appendChild(rootElement);

ReactDOM.createRoot(document.getElementById("app")).render(<AppEntry />);

// Unregister service workers (previous version-check implementation)
// TODO: Remove after some time
if ("serviceWorker" in navigator) {
    navigator.serviceWorker
        .getRegistrations()
        .then((registrations) => registrations.forEach((registration) => registration.unregister()))
        .catch(() => {
            // Best-effort cleanup; ignore.
        });
}
